var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.465,
    height: 21,
    viewBox: "0 0 21.465 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_transfer",
    "data-name": "icona transfer",
    transform: "translate(-205.767 -135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_transfer-2",
    "data-name": "icona transfer",
    transform: "translate(206 56.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3336",
    "data-name": "Raggruppa 3336",
    transform: "translate(0 81.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3335",
    "data-name": "Raggruppa 3335",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1869",
    "data-name": "Tracciato 1869",
    d: "M20.838,84.681l-2.97-3.314a.487.487,0,0,0-.742,0,.634.634,0,0,0,0,.828L19.2,84.509H.525a.589.589,0,0,0,0,1.172H19.2l-2.074,2.314a.634.634,0,0,0,0,.828.487.487,0,0,0,.742,0l2.97-3.314A.634.634,0,0,0,20.838,84.681Z",
    transform: "translate(0 -81.195)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3338",
    "data-name": "Raggruppa 3338",
    transform: "translate(0.008 89.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3337",
    "data-name": "Raggruppa 3337",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1870",
    "data-name": "Tracciato 1870",
    d: "M20.659,263.7H1.985l2.073-2.314a.635.635,0,0,0,0-.828.487.487,0,0,0-.742,0l-2.97,3.314a.635.635,0,0,0,0,.828l2.97,3.314a.487.487,0,0,0,.742,0,.635.635,0,0,0,0-.828l-2.073-2.313H20.659a.589.589,0,0,0,0-1.172Z",
    transform: "translate(-0.192 -260.387)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_791",
    "data-name": "Rettangolo 791",
    transform: "translate(206 135)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.aa056ead92c330596aafd7f2cceb5ec2.svg";
export { ForwardRef as ReactComponent };